import React, { useState, useEffect } from "react";
import { api } from "../../../../lib/api";

export function ScansPanel() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/scans-summary?since_days=30").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  return (
    <div className="bg-white border border-[#E5E0D8] rounded-2xl p-6" data-testid="scans-panel">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">QR-scan engagement · last {data.window_days}d</p>
          <p className="serif text-2xl mt-1">
            {data.total_scans_window} <span className="text-[#4A5C50] text-lg">physical scans by receivers</span>
          </p>
        </div>
        <div className="text-right flex gap-8">
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">All-time</p>
            <p className="serif text-2xl mt-1 mono" data-testid="scans-lifetime">{data.total_scans_all_time}</p>
          </div>
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">Unique cards (30d)</p>
            <p className="serif text-2xl mt-1 mono" data-testid="scans-unique">{data.unique_cards_scanned_window}</p>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50] mb-3">Most-scanned cards (lifetime)</p>
        {data.top_scanned.length === 0 ? (
          <p className="text-sm text-[#4A5C50]">No QR scans recorded yet — issued cards haven't been scanned by receivers in the wild.</p>
        ) : (
          <div className="divide-y divide-[#E5E0D8] border border-[#E5E0D8] rounded-xl overflow-hidden">
            {data.top_scanned.map((r) => (
              <div key={r.card_id} className="flex items-center gap-4 p-3 text-sm" data-testid={`scan-row-${r.card_id}`}>
                <span className="mono text-xs text-[#4A5C50] w-24">•••• {r.last4}</span>
                <span className="flex-1 truncate">{r.receiver_name}</span>
                <span className="text-xs text-[#4A5C50] mono hidden sm:inline">{r.last_scanned_at ? new Date(r.last_scanned_at).toLocaleString() : "—"}</span>
                <span className="mono font-semibold text-[#184A30] w-16 text-right">{r.scans}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
